import en, { SurveyTranslations } from "../translations/en";
import no from "../translations/no";
import { setDateLocale } from "../utils/date";

function useTranslations(lang: string): SurveyTranslations {
  switch (lang) {
    case "nb":
    case "no":
    case "nn":
      setDateLocale("nb-NO");
      return no;
    default:
      setDateLocale("en-GB");
      return en;
  }
}

export default useTranslations;
